<div class="grid">
  <div class="col-12">
    <div class="card" [ngStyle]="{'min-height': '4.5rem'}">
      <div class="flex flex-wrap justify-content-between">
        <span class="line-height-4">
          <span class="text-xl font-semibold">{{ 'attribute.period' | transloco}}:</span>&nbsp;
          <span *ngIf="firstShow" class="text-md font-medium text-secondary">
            {{ 'common.selectPeriod' | transloco }}
          </span>
          <span *ngIf="!firstShow" class="text-md font-medium text-secondary">
            {{ 'attribute.from' | transloco }} <b>{{this.specificPeriodRange[0] | date}}</b> {{
            'attribute.until' | transloco | lowercase}}
            <b>{{this.specificPeriodRange[1]
              | date}}</b>
          </span>
        </span>
        <div class="flex flex-wrap justify-content-end">
          <button
            [label]="'common.exportXls' | transloco"
            [disabled]="this.firstShow || this.isDataLoading"
            (click)="exportVisible = !exportVisible; exportFileType = ExportFileType.ANALYSIS_CONSUMPTION_AND_WORK"
            pButton
            class="p-button-secondary md:mr-2"
            icon="pi pi-file-excel"
          ></button>
          <p-button
            class="m-auto mr-0 mt-auto"
            [label]="'common.filters' | transloco"
            styleClass="p-button-secondary"
            icon="pi pi-sliders-h"
            (onClick)="filtersVisible = !filtersVisible"
          ></p-button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-4">
    <div class="card relative pt-2 pb-2 h-10rem">
      <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsLastHour' | transloco}}"
           tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
          {{'misc.overview.squeezedFruitsLastHour' | transloco}}
        </h4>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton height="2rem"></p-skeleton>
        </div>
      </div>
      <hr>
      <div class="flex h-4rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
        <span class="m-auto text-400 font-medium text-xl"
          *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.consumptionData?.squeezedFruitsLastHour == null || this.consumptionData?.squeezedFruitsLastHour == undefined || this.consumptionData?.squeezedFruitsLastHour < 0)">
          {{'empty.measures' | transloco}}</span>
        <span class="m-auto text-primary font-semibold text-5xl"
          *ngIf="!this.isDataLoading && this.consumptionData != null && this.consumptionData?.squeezedFruitsLastHour >= 0">
          {{ this.consumptionData.squeezedFruitsLastHour | number: '' : this.language}}</span>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton class="m-auto" height="3rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4">
    <div class="card relative pt-2 pb-2 h-10rem">
      <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsLastDay' | transloco}}"
           tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
          {{'misc.overview.squeezedFruitsLastDay' | transloco}}
        </h4>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton height="2rem"></p-skeleton>
        </div>
      </div>
      <hr>
      <div class="flex h-4rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
        <span class="m-auto text-400 font-medium text-xl"
          *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.consumptionData?.squeezedFruitsLastDay == null || this.consumptionData?.squeezedFruitsLastDay == undefined || this.consumptionData?.squeezedFruitsLastDay < 0)">
          {{'empty.measures' | transloco}}</span>
        <span class="m-auto text-primary font-semibold text-5xl"
          *ngIf="!this.isDataLoading && this.consumptionData != null && this.consumptionData?.squeezedFruitsLastDay >= 0">
          {{ this.consumptionData.squeezedFruitsLastDay | number: '' : this.language}}</span>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton class="m-auto" height="3rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4">
    <div class="card relative pt-2 pb-2 h-10rem">
      <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsLastMonth' | transloco}}"
           tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
          {{'misc.overview.squeezedFruitsLastMonth' | transloco}}
        </h4>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton height="2rem"></p-skeleton>
        </div>
      </div>
      <hr>
      <div class="flex h-4rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
        <span class="m-auto text-400 font-medium text-xl"
          *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.consumptionData?.squeezedFruitsLastMonth == null || this.consumptionData?.squeezedFruitsLastMonth == undefined || this.consumptionData?.squeezedFruitsLastMonth < 0)">
          {{'empty.measures' | transloco}}</span>
        <span class="m-auto text-primary font-semibold text-5xl"
          *ngIf="!this.isDataLoading && this.consumptionData != null && this.consumptionData?.squeezedFruitsLastMonth >= 0">
          {{ this.consumptionData.squeezedFruitsLastMonth | number: '' : this.language}}</span>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton class="m-auto" height="3rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-12 xl:col-4">
    <div class="card relative pt-2 pb-2" [ngStyle]="{height: '20rem'}">
      <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsByHourOfDay' | transloco}}"
           tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
          {{'misc.overview.squeezedFruitsByHourOfDay' | transloco}}
        </h4>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton height="2rem"></p-skeleton>
        </div>
      </div>
      <hr>
      <div #squeezedFruitsByHourOfDayDiv class="flex h-12rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
        <span class="m-auto text-400 font-medium text-xl"
          *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.squeezedFruitsByHourOfDay.data == null)">
          {{'empty.measures' | transloco}}</span>
        <span *ngIf="!firstShow && !this.isDataLoading && this.squeezedFruitsByHourOfDay?.data != null"
          class="m-auto text-primary font-semibold text-5xl text-center">
          <hr>
          <app-generic-graph name="squeezedFruitsByHourOfDay" [dataType]="'category'" [customSeries]="true"
            [categories]="this.squeezedFruitsByHourOfDay.categories" [data]="this.squeezedFruitsByHourOfDay.data"
            [height]="150" [width]="this.squeezedFruitsByHourOfDayDivWidth" chartType="column" class="mt-3"
            [pointFormat]="this.tooltipFormatter()" [plotOptions]="plotOptions"
            [(update)]="updateFlag">
          </app-generic-graph>
        </span>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton class="m-auto" height="13rem">
          </p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-6 xl:col-4">
    <div class="card relative pt-2 pb-2" [ngStyle]="{height: '20rem'}">
      <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsByDayOfWeek' | transloco}}"
           tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
          {{'misc.overview.squeezedFruitsByDayOfWeek' | transloco}}
        </h4>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton height="2rem"></p-skeleton>
        </div>
      </div>
      <hr>
      <div #squeezedFruitsByDayOfWeekDiv class="flex h-12rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
        <span class="m-auto text-400 font-medium text-xl"
          *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null ||this.squeezedFruitsByDayOfWeek.data == null)">
          {{'empty.measures' | transloco}}</span>
        <span *ngIf="!firstShow && !this.isDataLoading && this.squeezedFruitsByDayOfWeek?.data != null"
          class="m-auto text-primary font-semibold text-5xl text-center">
          <hr>
          <app-generic-graph name="squeezedFruitsByDayOfWeek" [customSeries]="true"
            [categories]="this.squeezedFruitsByDayOfWeek.categories" [data]="this.squeezedFruitsByDayOfWeek.data"
            [height]="150" [width]="this.squeezedFruitsByDayOfWeekDivWidth" chartType="column" class="mt-3"
            [pointFormat]="this.tooltipFormatter()" [plotOptions]="plotOptions">
          </app-generic-graph>
        </span>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton class="m-auto" height="13rem">
          </p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-6 xl:col-4">
    <div class="card relative pt-2 pb-2" [ngStyle]="{height: '20rem'}">
      <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsByMonthOfYear' | transloco}}"
           tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
          {{'misc.overview.squeezedFruitsByMonthOfYear' | transloco}}
        </h4>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton height="2rem"></p-skeleton>
        </div>
      </div>
      <hr>
      <div #squeezedFruitsByMonthOfYearDiv class="flex h-12rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
        <span class="m-auto text-400 font-medium text-xl"
          *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null ||this.squeezedFruitsByMonthOfYear.data == null)">
          {{'empty.measures' | transloco}}</span>
        <span *ngIf="!firstShow && !this.isDataLoading && this.squeezedFruitsByMonthOfYear?.data != null"
          class="m-auto text-primary font-semibold text-5xl text-center">
          <hr>
          <app-generic-graph name="squeezedFruitsByMonthOfYear" [customSeries]="true"
            [categories]="this.squeezedFruitsByMonthOfYear.categories" [data]="this.squeezedFruitsByMonthOfYear.data"
            [height]="150" [width]="this.squeezedFruitsByMonthOfYearDivWidth" chartType="column" class="mt-3"
            [pointFormat]="this.tooltipFormatter()" [plotOptions]="plotOptions">
          </app-generic-graph>
        </span>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton class="m-auto" height="13rem">
          </p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 xl:col-8">
    <div class="card pt-2 pb-2" [ngStyle]="{height: '54rem'}">
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
          {{'misc.overview.squeezedFruitsInSelectedPeriod' | transloco}}
        </h4>
        <div class="w-full" *ngIf="this.isDataLoading">
          <p-skeleton height="2rem"></p-skeleton>
        </div>
        <div class="flex flex-column md:flex-row justify-content-center p-fluid">
          <button
            [disabled]="this.firstShow || this.isDataLoading"
            type="button"
            pButton
            icon="pi pi-bars"
            class="p-button-secondary"
            label=""
            (click)="totalSqueezedFruitsAction.toggle($event); exportFileType = ExportFileType.ANALYSIS_CONSUMPTION_AND_WORK_CHART"
          ></button>
          <p-menu #totalSqueezedFruitsAction [popup]="true" [model]="chartActions" id="options" appendTo="body">
          </p-menu>
        </div>
      </div>
      <hr>
      <div *ngIf="firstShow" class="flex" style="height:650px">
            <span class="m-auto text-400 font-medium text-xl">
          {{'empty.period' | transloco}}</span>
      </div>
      <app-generic-graph
        *ngIf="!firstShow && !this.isDataLoading && this.graphMeasures"
        [fileName]="'misc.overview.squeezedFruitsInSelectedPeriod' | transloco"
        [exportFileType]="ExportFileType.ANALYSIS_CONSUMPTION_AND_WORK_CHART"
        [customSeries]="true"
        [data]="this.graphMeasures"
        [height]="650"
        [legend]="true"
        [name]="'attribute.value' | transloco"
        [yAxis]="graphAxis"
        chartType="line"
        tooltipDateFormat="%A, %e %b %Y, %H:%M:%S %Z"
        [pointFormat]="this.tooltipFormatterChart(this.squeezedFruitsTranslation)"
        #totalSqueezedFruitsChart
      >
      </app-generic-graph>
      <div class="w-full" *ngIf="this.isDataLoading">
        <p-skeleton height="650px"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="col-12 xl:col-4">
    <div class="grid">
      <div class="col-12">

        <div class="card pt-2 pb-2 h-10rem relative">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.totalSqueezedFruitsInPeriod' | transloco}}"
            tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
              {{'misc.overview.totalSqueezedFruitsInPeriod' | transloco}}
            </h4>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton height="2rem"></p-skeleton>
            </div>
          </div>
          <hr>
          <div class="flex h-4rem">
            <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
            <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.consumptionData?.totalSqueezedFruits == null || this.consumptionData?.totalSqueezedFruits == undefined
               || this.consumptionData?.totalSqueezedFruits < 0)">
              {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isDataLoading && this.consumptionData != null && this.consumptionData?.totalSqueezedFruits >= 0">
              {{this.consumptionData?.totalSqueezedFruits | number: '' : this.language}}</span>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton class="m-auto" height="3rem"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card pt-2 pb-2 h-10rem relative">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsAveragePerMachine' | transloco}}"
            tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
              {{'misc.overview.squeezedFruitsAveragePerMachine' | transloco}}
            </h4>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton height="2rem"></p-skeleton>
            </div>
          </div>
          <hr>
          <div class="flex h-4rem">
            <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
            <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.consumptionData?.squeezedFruitsAveragePerMachine == null || this.consumptionData?.squeezedFruitsAveragePerMachine == undefined
               || this.consumptionData?.squeezedFruitsAveragePerMachine < 0)">
              {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isDataLoading && this.consumptionData != null && this.consumptionData?.squeezedFruitsAveragePerMachine >= 0">
              {{this.consumptionData?.squeezedFruitsAveragePerMachine | number: '.0-2' : this.language}}</span>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton class="m-auto" height="3rem"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card pt-2 pb-2 h-10rem relative">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsByServiceHour' | transloco}}"
            tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
              {{'misc.overview.squeezedFruitsByServiceHour' | transloco}}
            </h4>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton height="2rem"></p-skeleton>
            </div>
          </div>
          <hr>
          <div class="flex h-4rem">
            <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
            <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.consumptionData?.squeezedFruitsAveragePerHour == null || this.consumptionData?.squeezedFruitsAveragePerHour == undefined
               || this.consumptionData?.squeezedFruitsAveragePerHour < 0)">
              {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isDataLoading && this.consumptionData != null && this.consumptionData?.squeezedFruitsAveragePerHour >= 0">
              {{this.consumptionData?.squeezedFruitsAveragePerHour | number: '.0-2' : this.language}}</span>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton class="m-auto" height="3rem"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card pt-2 pb-2 h-10rem relative">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.squeezedFruitsByDayAndMachine' | transloco}}"
            tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
              {{'misc.overview.squeezedFruitsByDayAndMachine' | transloco}}
            </h4>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton height="2rem"></p-skeleton>
            </div>
          </div>
          <hr>
          <div class="flex h-4rem">
            <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
            <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.consumptionData?.squeezedFruitsAveragePerDayAndMachine == null || this.consumptionData?.squeezedFruitsAveragePerDayAndMachine == undefined
               || this.consumptionData?.squeezedFruitsAveragePerDayAndMachine < 0)">
              {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isDataLoading && this.consumptionData != null && this.consumptionData?.squeezedFruitsAveragePerDayAndMachine >= 0">
              {{this.consumptionData?.squeezedFruitsAveragePerDayAndMachine | number: '.0-2' : this.language}}</span>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton class="m-auto" height="3rem"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card pt-2 pb-2 h-10rem relative">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.totalSqueezedFruitsActivation' | transloco}}"
            tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isDataLoading">
              {{'misc.overview.totalSqueezedFruitsActivation' | transloco}}
            </h4>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton height="2rem"></p-skeleton>
            </div>
          </div>
          <hr>
          <div class="flex h-4rem">
            <span class="m-auto text-400 font-medium text-xl" *ngIf="firstShow">
          {{'empty.period' | transloco}}</span>
            <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!firstShow && !this.isDataLoading && (this.consumptionData == null || this.consumptionData?.totalSqueezedFruitsActivation == null || this.consumptionData?.totalSqueezedFruitsActivation == undefined
               || this.consumptionData?.totalSqueezedFruitsActivation < 0)">
              {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isDataLoading && this.consumptionData != null && this.consumptionData?.totalSqueezedFruitsActivation >= 0">
              {{this.consumptionData?.totalSqueezedFruitsActivation | number: '' : this.language}}</span>
            <div class="w-full" *ngIf="this.isDataLoading">
              <p-skeleton class="m-auto" height="3rem"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="alias">{{'attribute.alias' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.alias" [focus]="filtersVisible"
               appAutoFocus pInputText class="w-full" id="alias" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="machine">{{'attribute.serialNumber' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.machineUuids" [placeholder]="'select.generic' | transloco"
                       [filter]="true" filterBy="serial" display="chip" styleClass="w-full" appendTo="body" [options]="machines"
                       id="machine" optionLabel="serial" optionValue="machineUuid">
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organization">{{'model.organization' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-treeSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
          [propagateSelectionUp]="false" [propagateSelectionDown]="false" display="chip" appendTo="body"
          [options]="hierarchy" [metaKeySelection]="false" selectionMode="checkbox" id="organization">
        </p-treeSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="model">{{'attribute.model' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.machineModelUuids" [placeholder]="'select.generic' | transloco"
          [filter]="true" filterBy="modelName" display="chip" styleClass="w-full" appendTo="body" [options]="models"
          id="model" optionLabel="modelName" optionValue="machineModelUuid">
          <ng-template let-model pTemplate="item">
            <div class="flex align-items-center">
              <div style="width:30px;">
                <img [src]="model.image" [alt]="model.modelName" style="max-height: 30px;max-width: 100%;" />
              </div>
              <p class="mb-0 ml-1 p-0">{{model.modelName}}</p>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="country">{{'attribute.country' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.countries" [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="countries"
          (onChange)="onCountryChange($event)" id="country" optionLabel="name" optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="state">{{'attribute.province' | transloco}}/{{'attribute.state' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.states" [placeholder]="'select.generic' | transloco" [filter]="true"
          display="chip" styleClass="w-full" appendTo="body" [options]="filteredStates" [disabled]="isStateDisabled"
          (onChange)="onStateChange($event)" id="state" optionLabel="name" optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="locality">{{'attribute.locality' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.localities" [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="filteredLocalities"
          [disabled]="isLocalityDisabled" id="locality" optionLabel="name" optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="range">{{'attribute.dateRange' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-calendar id="range" styleClass="w-20rem" inputStyleClass="w-full" [ngModel]="tempPeriodRange" [monthNavigator]="true"
          [yearNavigator]="true" [yearRange]="availableYearRange" (ngModelChange)="validatePeriodRange($event)"
          selectionMode="range" [readonlyInput]="true" inputId="range" dateFormat="dd/mm/yy" appendTo="body"
          [placeholder]="'select.dateRange' | transloco" [showButtonBar]="true" [showIcon]="true" [firstDayOfWeek]="1">
        </p-calendar>
      </div>
      <div class="col-12">
        <p-button [label]="'common.filter' | transloco" [disabled]="!(
            currentFilters.from && currentFilters.until &&
            (currentFilters.alias ||
            (organizations != null && organizations.length > 0) ||
            (currentFilters.localities != null && currentFilters.localities.length > 0) ||
            (currentFilters.countries != null && currentFilters.countries.length > 0) ||
            (currentFilters.states != null && currentFilters.states.length > 0) ||
            (currentFilters.machineUuids != null && currentFilters.machineUuids.length > 0) ||
            (currentFilters.machineModelUuids != null && currentFilters.machineModelUuids.length > 0))
          )" (onClick)="filtersVisible = false; applyFilters()" styleClass="p-button-primary mx-2 mt-2" type="button">
        </p-button>
        <p-button [label]="'common.clear' | transloco" (click)="resetFilters(); filtersVisible = false; applyFilters()"
          styleClass="p-button-danger" type="button"></p-button>
      </div>
    </div>
  </div>
</p-sidebar>

<app-export-xls *ngIf="exportVisible"
                [content]="getContentExport()"
                [typeContent]="'CONSUMPTION'"
                [exportFileType]="exportFileType"
                [typeExport]="'XLSX'"
                [(visible)]="exportVisible">
</app-export-xls>
